import { create } from 'zustand';
import { api, setToken, getToken } from '../lib/api';

export interface AuthUser {
  id: string;
  email: string;
  fullName: string;
  role: string;
}

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
  error: string | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  loadCurrentUser: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,
  error: null,

  async login(email, password) {
    set({ loading: true, error: null });
    try {
      const { data } = await api.post('/api/auth/login', { email, password });
      setToken(data.token);
      set({ user: data.user, loading: false });
    } catch (err: any) {
      const message =
        err.response?.data?.error ||
        err.response?.data?.errors?.[0]?.msg ||
        'Login fehlgeschlagen';
      set({ error: message, loading: false });
      throw err;
    }
  },

  logout() {
    setToken(null);
    set({ user: null });
  },

  async loadCurrentUser() {
    if (!getToken()) return;
    try {
      const { data } = await api.get('/api/auth/me');
      set({ user: data.user });
    } catch {
      setToken(null);
      set({ user: null });
    }
  }
}));
